import { z } from 'zod'

// Domain enums shared between the response schemas and the form schemas.
// Kept here so the member lists exist once — they were previously copy-pasted
// between device.ts and forms.ts, and UserRole had three separate declarations.

// Matches TypeEnum in server/schema.yml.
export const deviceTypeEnum = z.enum([
  'telemetry',
  'isense',
  'variateur',
  'relais',
  'starter',
  'generic',
])
export type DeviceTypeName = z.infer<typeof deviceTypeEnum>

// Matches DatatypeEnum / ChartEnum in server/schema.yml (generic device
// schema fields).
export const datatypeEnum = z.enum([
  'int',
  'float',
  'text',
  'date',
  'bool',
  'json',
  'csv',
])

export const chartEnum = z.enum(['line', 'bar', 'pie', 'none'])

// Application-side role list (RBAC roles are data, but the UI offers this
// fixed set). Previously declared in settings/types.ts and again in
// user-table.tsx.
export const userRoleEnum = z.enum(['admin', 'operator', 'viewer', 'engineer'])
export type UserRole = z.infer<typeof userRoleEnum>
